export const toError = (error) => {
    if (error instanceof Error) {
        return error;
    }
    if (typeof error === 'string') {
        return new Error(error);
    }
    try {
        return new Error(JSON.stringify(error));
    }
    catch {
        return new Error(String(error));
    }
};
//# sourceMappingURL=error.js.map